import { FC } from 'react';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';
import { StatusPill } from '@dynamika-shared/ui/StatusPill/StatusPill';
import { StudyStatusEnum } from '@dynamika-shared/types/status';

interface SubjectListHeaderProps {
  clinicalTrialName?: string;
  status?: string;
}

export const SubjectListHeader: FC<SubjectListHeaderProps> = ({
  clinicalTrialName,
  status,
}) => {
  return (
    <div className='flex items-center justify-between pb-2 pt-3'>
      <div className='text-12 flex items-center'>
        {clinicalTrialName && (
          <TruncatedText
            text={clinicalTrialName}
            truncate
            tooltip
            className='mr-1 text-6xl font-medium max-w-[50rem] leading-[55px]'
          />
        )}

        {status && <StatusPill status={status as StudyStatusEnum} />}
      </div>
    </div>
  );
};
